<template>
  <!-- <b-row> -->
  <!-- <b-col lg="6" md="6" sm="12" cols="12"> -->
  <b-row>
    <b-col>
      <label class="mb-0">{{ $t("5000.deptstrdetails") }}</label>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="6" md="6" sm="6" cols="6">
        <div class="field">
          <!-- <label>Department</label> -->

          <DropDownCustom
            v-model="selectOptionsDept1.deptValue"
            :items="selectOptionsDept1.deptOptions"
            @update:modelValue="loadSubDepartment"
            name="Department"
            :label="$t('5000.department')"
            :rules="{ required: false }"
            id="Department"
            showClear
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="6" cols="6">
        <div class="field">
          <!-- <label>Sub Department</label> -->
          <DropDownCustom
            v-model="selectOptionsDept1.subDeptValue"
            :items="selectOptionsDept1.subDeptOptions"
            @update:modelValue="update"
            name="Sub Department"
            :label="$t('5000.subdepartment')"
            :rules="{ required: false }"
            id="Sub Department"
          />
        </div>
      </b-col>
    </b-row>
  </div>
  <!-- </b-col> -->

  <!-- </b-row> -->
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import DropDownCustom from "../../../../components/FormComponents/Dropdown.vue";
import commonservice from "../../Service/StoreService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
export default defineComponent({
  components: {
    DropDownCustom,
  },
  props: {
    // selectDepartment: {
    //     type: null
    // },
    // departmentOptions: {
    //     type: Array
    // },
    // selectSubDepartment: {
    //     type: null
    // },
    // subDepartmentOptions: {
    //     type: Array
    // },
    value: {},
    branchId: {
      type: String,
    },
  },

  setup(props, { emit }) {
    const selectOptionsDept1 = reactive({
      deptValue: ref(),
      deptOptions: [],
      subDeptValue: ref(),
      subDeptOptions: [],
    });
    const BranchId = ref();
    const router = useRoute();
    const storeId = router.query.storeId;
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchIdLog = Number(session.BranchId);
    watch(
      () => selectOptionsDept1.deptValue,
      (newVal) => {
        debugger;
        // alert(newVal)
        if (newVal != "") {
          loadSubDepartment();
        }
      }
    );
    watch(
      () => props.branchId,
      (newVal) => {
        debugger;
        BranchId.value = newVal;
        //  LoadDepartment()
      }
    );

    onMounted(() => {
      debugger;

      Object.assign(selectOptionsDept1, props.value);
      LoadDepartment();
    });
    function update() {
      debugger;
      emit("update:modelValue", selectOptionsDept1);
    }
    async function LoadDepartment() {
      debugger;
      // selectOptionsDept1.deptValue = '';
      // selectOptionsDept1.subDeptValue = '';
      var object_data = {
        Dml_Indicator: "DP",
        branch_id: parseInt(BranchId.value),
        hospital_id: "USH00005",
      };
      const result = await commonservice.LoadDepartment();
      console.log(result);
      // selectOptionsDept.value.deptOptions = result.data.Table.map(
      //     (v) => ({
      //         label: v["name"],
      //         value: v["master_category_department_id"]
      //     }));
      // let branch = BranchIdLog;
      // if (BranchId.value) {
      //     branch = Number(BranchId.value);
      // }
      selectOptionsDept1.deptOptions = result["result"]
        .filter((item) => item.OrganizationId == HospitalId)
        .map((item) => {
          item.name = item.Name;
          item.value = item.ID;
          return item;
        });
      // if (!!deptId) {
      //     selectOptionsDept1.deptValue = deptId;
      // }
      if (!selectOptionsDept1.deptValue) {
        selectOptionsDept1.subDeptValue = null;
      }
      update();
    }
    //Loading Sub Department on Department change
    async function loadSubDepartment() {
      try {
        debugger;
        //selectOptionsDept1.subDeptValue = '';
        // if (!!deptId) {
        //     selectOptionsDept1.deptValue = deptId;
        // }
        // alert(selectOptionsDept1.deptValue)
        // var object_data = {
        //     Dml_Indicator: "SDP",
        //     hospital_id: "USH00005",
        //     Master_cd_id: selectOptionsDept1.deptValue
        // }
        if (selectOptionsDept1.deptValue != null) {
          const result = await commonservice.LoadSubDepartment();
          console.log(result);
          selectOptionsDept1.subDeptOptions = result["result"]
            .map((item) => {
              item.name = item.Name;
              item.value = item.ID;
              return item;
            })
            .filter(
              (item) => item.DepartmentId == selectOptionsDept1.deptValue
            );
        }

        // }
        update();
      } catch (error) {}
    }
    return {
      selectOptionsDept1,
      update,
      LoadDepartment,
      loadSubDepartment,
    };
  },
});
</script>
